// extracted by mini-css-extract-plugin
export default {"backgroundImage":"BackgroundImage_common_backgroundImage__4L-aj"};